import moment from "moment";
import { PolicyFullObject } from "../types/insurance.ts";

export const POLICY_FULL_OBJECT: PolicyFullObject = {
  policyId: "0",
  policyNumber: "",
  insuranceCompanyId: "",
  insuranceCompany: "",
  policyTypeId: 5,
  policyType: "0",
  agentId: "",
  agent: "",
  divisionId: "",
  divisionName: "",
  policyStatus: "1",
  vehicleType: "",
  insuredSum: "",
  policySum: 0,
  contractDate: moment().format("DD/MM/YYYY"),
  startDate: moment().format("DD/MM/YYYY"),
  endDate: moment().add(1, "year").subtract(1, "days").format("DD/MM/YYYY"),
  reportDate: moment().format("DD/MM/YYYY"),
  installmentsCount: 0,
  policyAdditionalData: "",
  clientId: "",
  carId: "",
  gfSum: 0,
  agentCommissionPercentage: "0",
  officeCommissionPercentage: "0",
  vehicleRegistrationNumber: "",
  vehicleCertificate: "",
  vehicleBrand: "",
  engineCapacity: "",
  vehicleUsage: "",
  manufactureYear: "",
  vehicleOtherData: "",
  insuranceClientPin: "",
  insuranceClientName: "",
  insuranceClientPhone: "",
  insuranceClientAddress: "",
  clientOtherData: "",
  vehicleModel: "",
  zeroCommission: 0,
  vehicleVolume: "",
  additionalCount: "",
  twoPercentAmount: 0,
  annexes: [],
  chassisNumber: "",
};
